<template>
    <div class="detail">
        <router-link class="btn primary" :to="{ name: 'overview' }">
            <i data-feather="grid" /> Overview
        </router-link>
        
        <h1>{{ project.name }}</h1>
        {{ message }}
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { FETCH_PROJECT } from "@/store/actions.type"
import store from "@/store" // eslint-disable-line

export default {
    name: 'detail',
    props: {
        hash: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            message: ''
        }
    },
    beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(FETCH_PROJECT, to.params.hash)
        ]).then(() => {
            next();
        });
    },
    computed: {
        ...mapGetters(['isAuthenticated', 'project'])
    }
}
</script>

<style>

</style>